import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import sensorsystem from "../images/Sensor.jpg";
import WirelessMotionSensorLEDLight from "../images/Wireless Motion Sensor LED Light.jpg";
import DoorSensorsinaSecuritySystem from "../images/Door Sensors in a Security System.jpg"
import WirelessParkingSensors from "../images/Wireless Parking Sensors.jpg";

function Senor() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <div className="cctvfotageberhampore">
        <div className="album py-1">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Senor System</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

       <div className='computershopberhampore'>
           <br />
      <div className="album py-1">

        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={WirelessMotionSensorLEDLight} className="card-img-top" alt="Wireless Motion Sensor LED Light" />
                <div className='card-body'>
                  <h5 style={{color:"darkblue"}} className='mb-1'><b>Wireless Motion Sensor LED Light</b></h5>
                  <p className='mb-0'>Best Brand Wireless Sendor Available</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={DoorSensorsinaSecuritySystem} className="card-img-top" alt="DoorSensorsinaSecuritySystem" />
                <div className='card-body'>
               <h5 style={{color:"darkblue"}} className='mb-1'><b> Door Sensors </b></h5>
                  <p className='mb-0'>Best Brand Door Sensors  Available</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3" >
              <div className='card shadow'>
                <img src={WirelessParkingSensors} className="card-img-top" alt="Wireless Parking Sensors"/>
                <div className='card-body'>
                   <h5 style={{color:"darkblue"}} className='mb-1'><b>Wireless Parking Sensors</b></h5>
                  <p className='mb-0'>Best Brand Wireless Parking Sensors Available</p>
                </div>
              </div>
            </div>

            

          </div>
        </div>
      </div>
         <br />
         <br/>
      </div>
      <br />
      <div className="album py-1">

        <div className="container ">
          <div className="row">

            <div className="col-md-8">
              <h1 style={{color:"#030D54"}}> <b>Senor System</b></h1>
              <hr />
              <p className='justify'>Our Sensor System provides smart, real-time protection for homes and businesses across Murshidabad. From motion sensors and door/window sensors to smoke, fire, gas, and vibration alerts, we deliver reliable monitoring for maximum safety. Easy installation, quick response, and long-lasting performance to keep your property secure 24/7</p>
              <br />
              
               <a className='mb-3' href='tel: 9064797437'>Help Line No. 9064797437</a>
               <br/>
               <br/>
            </div>
            <div className="col-md-4">
                    <img src={sensorsystem} className="d-block w-100" alt="sensorsystem"/>

            </div>
          </div>

        </div>
      </div>

  <br/>
    </div>
  )
}

export default Senor